module.exports = __webpack_public_path__ + "f9c453020aa6dcb3700e03ba742a4682.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/opensans-semibolditalic/opensans-semibolditalic.ttf
// module id = ./src/styles/fonts/opensans-semibolditalic/opensans-semibolditalic.ttf
// module chunks = index